import React, { Component, useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table } from 'reactstrap';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

const VendServerVisibility = (props) => {

    const dispatch = useDispatch()
    const selectRedux = state => state;
    const reduxData = useSelector(selectRedux);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        getTableData();
    }, [])

    useEffect(() => {
        getTableData();
    }, [props.servpk])

    function getTableData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            servpk: props.servpk
        }
        fetch('GetVendServerVis', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTableData(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    return (<div>
        <Table className="halfOfParent">
            <thead>
                <tr>
                    <th>Visibility</th>
                    <th>Active</th>
                </tr>
            </thead>
            <tbody>
                {tableData.map(item => (
                    <tr>
                        <td>{item.type}</td>
                        <td>{item.active}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    </div>)
}

export default VendServerVisibility;